import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';

const GIORNI = [['lun', 'Lunedì'], ['mar', 'Martedì'], ['mer', 'Mercoledì'], ['gio', 'Giovedì'],
                ['ven', 'Venerdì'], ['sab', 'Sabato'], ['dom', 'Domenica']];

export default function PianificazioneSsmateDialog({ open, onClose }) {
  const [p, setP] = useState({});
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/ssmate/bulk/preview`).then(r => setP(r.data.pianificazione || {})).catch(() => {});
  }, []);
  useEffect(() => { if (open) load(); }, [open, load]);

  if (!open) return null;

  const DEFAULT_DAY = { attivo: false, dalle: '21:00', alle: '23:30' };
  const giorno = (k) => p[k] || DEFAULT_DAY;
  // updater funzionale: parte sempre da s[k] (non dal p catturato al render)
  const setGiorno = (k, patch) => setP(s => ({ ...s, [k]: { ...(s[k] || DEFAULT_DAY), ...patch } }));

  const salva = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/ssmate/pianificazione`, { pianificazione: p });
      toast.success('Pianificazione salvata');
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore salvataggio'); }
    finally { setBusy(false); }
  };

  return createPortal(
    // sopra la gestione agenti (11000), da cui la si apre: prima ci finiva sotto e non si vedeva
    <div className="confirm-overlay" style={{ zIndex: 12500 }} onClick={() => !busy && onClose()}>
      <div className="confirm-dialog" style={{ maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <div className="confirm-title">Fascia oraria agente SSMATE</div>
        <div style={{ fontSize: 12.5, color: '#64748b', marginBottom: 10 }}>
          L'agente lavora solo nelle fasce attive. Fuori fascia va in attesa e riprende da solo.
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {GIORNI.map(([k, lbl]) => {
            const g = giorno(k);
            return (
              <div key={k} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, width: 108 }}>
                  <input type="checkbox" checked={!!g.attivo} onChange={e => setGiorno(k, { attivo: e.target.checked })} />
                  {lbl}
                </label>
                <input type="time" value={g.dalle} disabled={!g.attivo} onChange={e => setGiorno(k, { dalle: e.target.value })} />
                <span>–</span>
                <input type="time" value={g.alle} disabled={!g.attivo} onChange={e => setGiorno(k, { alle: e.target.value })} />
                <button type="button" className="btn" style={{ fontSize: 11, padding: '2px 8px' }} disabled={busy}
                  onClick={() => setGiorno(k, { attivo: true, dalle: '00:00', alle: '23:59' })}>Tutto il giorno</button>
              </div>
            );
          })}
        </div>
        <div className="confirm-btns" style={{ marginTop: 14 }}>
          <button className="btn btn-primary" disabled={busy} onClick={salva}>{busy ? '…' : 'Salva'}</button>
          <button className="btn btn-secondary" disabled={busy} onClick={onClose}>Annulla</button>
        </div>
      </div>
    </div>,
    document.body);
}
